module.exports = __webpack_public_path__ + "fonts/Uniplast.aec242e.ttf";